import { Mod, ModScope, ModState } from "./types/mod";

export const sortMods = (mods: Mod[]): Mod[] =>
{
	return [...mods].sort((a, b) =>
	{
		// Primary: Selected state first
		const aSelected = a.state === ModState.Selected ? 0 : 1;
		const bSelected = b.state === ModState.Selected ? 0 : 1;
		if (aSelected !== bSelected) return aSelected - bSelected;

		// Secondary: Sort by scope (Required > Optional > Server)
		const scopeOrder = { [ModScope.Required]: 0, [ModScope.Optional]: 1, [ModScope.Server]: 2 };
		const aScope = a.scope ? scopeOrder[a.scope] ?? 3 : 3;
		const bScope = b.scope ? scopeOrder[b.scope] ?? 3 : 3;
		if (aScope !== bScope) return aScope - bScope;

		// Tertiary: Alphabetical by title
		return a.title.localeCompare(b.title);
	});
};
